//
// DISCLAIMER
//
// Copyright 2026 ArangoDB GmbH, Cologne, Germany
//

import Downloader from "js-file-downloader";
import moment from "moment";
import Auth from "../../auth/Auth";

// DownloadEverestInvoice downloads the invoice PDF, saving it as
// "<invoice date YYYY.MM.DD>_<invoice number>.pdf" rather than the raw UUID.
export const DownloadEverestInvoice = async (invoiceUUID: string, auth: Auth, invoiceDate?: Date | string, invoiceNumber?: string) => {
  const fileURL = `/downloads/everest-invoices/${invoiceUUID}.pdf`;
  const datePart = invoiceDate ? moment(invoiceDate).format("YYYY.MM.DD") : "";
  const numberPart = (invoiceNumber || invoiceUUID || "invoice").replace(/[^\w.-]+/g, "-");
  const filename = `${[datePart, numberPart].filter(Boolean).join("_")}.pdf`;
  const downloader = new Downloader({
    url: fileURL,
    filename,
    headers: [{ name: "Authorization", value: `bearer ${auth.getAccessToken()}` }],
  });
  await downloader;
};
